var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTesting1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 91,
    viewBox: "0 0 82 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.9371C4.5 12.7921 10.2921 7 17.4371 7H55.5629C62.7079 7 68.5 12.7921 68.5 19.9371V58.0629C68.5 65.2079 62.7079 71 55.5629 71H17.4371C10.2921 71 4.5 65.2079 4.5 58.0629V19.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4371 7.40428H55.5629C62.4846 7.40428 68.0957 13.0154 68.0957 19.9371V58.0629C68.0957 64.9846 62.4846 70.5957 55.5629 70.5957H17.4371C10.5154 70.5957 4.90428 64.9846 4.90428 58.0629V19.9371C4.90428 13.0154 10.5154 7.40428 17.4371 7.40428Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3401_4523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4299 39.0007C24.4299 39.0007 28.7633 30.334 36.3466 30.334C43.9299 30.334 48.2633 39.0007 48.2633 39.0007C48.2633 39.0007 43.9299 47.6673 36.3466 47.6673C28.7633 47.6673 24.4299 39.0007 24.4299 39.0007Z",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3445 42.25C38.1394 42.25 39.5945 40.7949 39.5945 39C39.5945 37.2051 38.1394 35.75 36.3445 35.75C34.5496 35.75 33.0945 37.2051 33.0945 39C33.0945 40.7949 34.5496 42.25 36.3445 42.25Z",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4523",
    x: -8.43711,
    y: 0.531445,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3401_4523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(23.345 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting1);
export default __webpack_public_path__ + "static/media/Testing1.be470d488b5a63040bd5eae3c8131be7.svg";
export { ForwardRef as ReactComponent };